import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ScrollingBanner from '../components/ScrollingBanner';
import WelcomeSection from '../components/WelcomeSection';
import ServicesSection from '../components/ServicesSection';
import CommunityParticipation from '../components/CommunityParticipation';
import NDISProviderSection from '../components/NDISProviderSection';
import BlogsSection from '../components/BlogsSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import StickyCallButton from '../components/StickyCallButton';
import SEO from '../components/SEO';

const HomePage = () => {
  return (
    <div>
      <SEO description="Life Care and Wellness provides trusted NDIS disability support services in Brisbane, Logan & surrounding areas. Support Coordination, Mental Health, SLES, Counselling and more." />
      <Header />
      <Hero />
      <ScrollingBanner />
      <WelcomeSection />
      <ServicesSection />
      <CommunityParticipation />
      <NDISProviderSection />
      <BlogsSection />
      <ContactSection />
      <Footer />
      <StickyCallButton />
    </div>
  );
};

export default HomePage;
